const { container } = require('@/container');

/**
 * This class represents an error that occurs while saving a payment against an order in the API.
 */
class PaymentSaveError extends Error {
    /**
     * @param {string} errorTypeLangKey
     * @param {Error} paymentError
     */
    constructor(errorTypeLangKey, paymentError) {
        // Build a user-friendly message based on the error type.
        let message = container.langService.getText('PAYMENT.' + errorTypeLangKey);
        if (paymentError?.message) {
            message += ' ' + paymentError.message;
        }

        super(message);

        /**
         * @type {Error}
         */
        this.paymentError = paymentError;

        /**
         * @type {Order|null}
         */
        this.order = null;

        /**
         * The array of payments that is currently saved against the order and has been returned by the API.
         *
         * @type {Payment[]|null}
         */
        this.hydratedConfirmedPayments = null;

        /**
         * @type {OrderAdjustmentResponse|null}
         */
        this.orderAdjustmentResponse = null;

        /**
         * The array of payments that was sent to the API to be saved against the order.
         *
         * @type {Payment[]|null}
         */
        this.newPayments = null;
    }

    setOrder(order) {
        this.order = order;
        return this;
    }

    /**
     * @param {Payment[]} hydratedConfirmedPayments
     * @returns {PaymentSaveError}
     */
    setHydratedConfirmedPayments(hydratedConfirmedPayments) {
        this.hydratedConfirmedPayments = hydratedConfirmedPayments;
        return this;
    }

    /**
     * @param {Payment[]} newPayments
     * @returns {PaymentSaveError}
     */
    setNewPayments(newPayments) {
        this.newPayments = newPayments;
        return this;
    }

    /**
     * @param {OrderAdjustmentResponse} orderAdjustmentResponse
     * @returns {PaymentSaveError}
     */
    setOrderAdjustmentResponse(orderAdjustmentResponse) {
        this.orderAdjustmentResponse = orderAdjustmentResponse;
        return this;
    }
}

PaymentSaveError.PERSIST_CLIENT_PAYMENT_ERROR = 'PERSIST_CLIENT_PAYMENT_ERROR';
PaymentSaveError.PERSIST_CLIENT_REFUND_ERROR = 'PERSIST_CLIENT_REFUND_ERROR';
PaymentSaveError.SERVER_REFUND_ERROR = 'SERVER_REFUND_ERROR';
PaymentSaveError.SERVER_REFUND_GET_PAYMENTS_ERROR = 'SERVER_REFUND_GET_PAYMENTS_ERROR';

module.exports = PaymentSaveError;
